import { ConfigService } from "./ConfigService";

export const config = new ConfigService();
